import { useState } from "react";

import styled from "styled-components/macro";

import { signupListTypeOptions } from "Signups/SharedComponents/signupListTypeOptions";
import { useSignups } from "Signups/state";
import { motion } from "framer-motion";

import FnrDividerLine from "UI/FnrDividerLine/FnrDividerLine";
import { FnrToggle, FnrToggleItems } from "UI/FnrToggle2";

import { Subtitle } from "../../";

import SignupTypeBox from "./SignupTypeBox";
import TemplateBox from "./TemplateBox";

export default function ChooseType({
  typeID,
  setTypeID,
  hasSignupPayments,
  hasFundIt,
  setTab,
  isSuperAdmin,
  isAdminOfAnyGroup,
}) {
  const [{ signupListTemplates }] = useSignups();

  const templatesToUse =
    signupListTemplates.length > 0
      ? signupListTemplates
      : signupListTypeOptions;

  const [stagedValue, setStagedValue] = useState(typeID);

  const updateValue = (newID) => {
    if (stagedValue === newID) setTimeout(() => setTab("title"), 200);
    setStagedValue(newID);
  };

  const checkAnimationComplete = ({ opacity }) => {
    if (opacity === 1) setTypeID(stagedValue);
  };

  const signupTemplateSelected = (newID) => {
    if (stagedValue === newID) updateValue(newID);
    else {
      setStagedValue(newID);
      setTimeout(() => setTypeID(newID), 150);
    }
  };

  return (
    <Wrapper>
      <Subtitle>What type of signup are you making?</Subtitle>
      <FnrToggle
        style={{ border: "none", background: "none", marginLeft: -14 }}
        hoverStyle={{ borderRadius: 14 }}
      >
        <FnrToggleItems>
          {templatesToUse.map((templateInfo, index) => {
            if (signupListTemplates.length > 0) {
              //transform so it works for templates or types
              templateInfo.label = templateInfo.signupListTemplateTitle;
              templateInfo.icon = templateInfo.signupListTemplateIcon;
              templateInfo.text = templateInfo.signupListTemplateDescription;
              templateInfo.ID = templateInfo.signupListID;
            }

            return (
              <TemplateBox
                key={templateInfo.ID}
                {...templateInfo}
                index={index}
                selected={templateInfo.ID === stagedValue}
                onClick={updateValue}
                checkAnimationComplete={checkAnimationComplete}
                hasSignupPayments={hasSignupPayments}
                hasFundIt={hasFundIt}
                isSuperAdmin={isSuperAdmin}
                isAdminOfAnyGroup={isAdminOfAnyGroup}
                duplicate={signupListTemplates.length > 0}
              />
            );
          })}
          {signupListTemplates.length > 0 && (
            <MoreTypesWrapper
              initial={{ opacity: 0, y: 40 }}
              animate={{
                opacity: 1,
                y: 0,
                transition: { delay: signupListTemplates.length * 0.05 },
              }}
            >
              <FnrDividerLine
                title="More Options"
                style={{ margin: 18, marginBottom: 6 }}
              />
              <SignupTypes>
                {signupListTypeOptions.map((signupTypeInfo) => {
                  return (
                    <SignupTypeBox
                      key={signupTypeInfo.ID}
                      {...signupTypeInfo}
                      onClick={signupTemplateSelected}
                    />
                  );
                })}
              </SignupTypes>
            </MoreTypesWrapper>
          )}
        </FnrToggleItems>
      </FnrToggle>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-top: 24px;
`;

const SignupTemplates = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

const MoreTypesWrapper = styled(motion.div)``;

const SignupTypes = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
